@use "sass:color";
@use "@/styles/variables/fonts" as *;
@use "@/styles/themes/themes";

.themeButton {
  user-select: none;
  padding: 10px;
  border-radius: 4px;
  width: 100%;
  min-height: 2.5rem;
  font-size: $small;

  &:hover {
    cursor: pointer;
  }
}

.disabled {
  @include themes.theme() {
    background-color: themes.themeValue(background-disabled);
    color: themes.themeValue(text-disabled);
    border: 1px solid themes.themeValue(border-disabled);
  }
  pointer-events: none;
}
